export const categories = [
  { id: "consumer", label: "消费维权", icon: "ri-shield-user-line", color: "primary" },
  { id: "society", label: "社会民生", icon: "ri-community-line", color: "accent" },
  { id: "industry", label: "行业黑料", icon: "ri-building-2-line", color: "secondary" },
  { id: "environment", label: "公共环境", icon: "ri-leaf-line", color: "primary" },
  { id: "traffic", label: "交通安全", icon: "ri-traffic-light-line", color: "accent" },
  { id: "food", label: "食品安全", icon: "ri-restaurant-line", color: "secondary" },
  { id: "property", label: "物业纠纷", icon: "ri-home-gear-line", color: "primary" },
  { id: "digital", label: "网络欺诈", icon: "ri-spy-line", color: "accent" },
];